<div class="p-0 overflow-hidden rounded-2xl border-none">
    <!-- Header -->
    <div class="bg-slate-50 px-6 py-4 border-b border-slate-100 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-blue-100 text-blue-600 rounded-lg">
          <lucide-angular [img]="ListPlusIcon" class="w-5 h-5"></lucide-angular>
        </div>
        <div>
          <h2 class="text-lg font-bold text-slate-800 m-0">Bulk Add Options</h2>
          <p class="text-xs text-slate-500">Add multiple choices at once</p>
        </div>
      </div>
      <button (click)="close()" class="text-slate-400 hover:text-slate-600 transition-colors">
          <lucide-angular [img]="CloseIcon" class="w-5 h-5"></lucide-angular>
      </button>
    </div>

    <!-- Content -->
    <div class="p-6">
      <div class="mb-4 flex items-start gap-3 p-3 bg-amber-50 rounded-lg border border-amber-100">
        <lucide-angular [img]="InfoIcon" class="w-4 h-4 text-amber-600 mt-0.5"></lucide-angular>
        <p class="text-xs text-amber-800 leading-relaxed">
          Type or paste your options below. <strong>Each new line</strong> will become a separate choice in your list.
        </p>
      </div>

      <div class="relative group">
        <textarea 
          [(ngModel)]="bulkText" 
          class="w-full h-56 p-4 text-slate-700 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all resize-none font-sans text-sm leading-6"
          placeholder="Option 1&#10;Option 2&#10;Option 3&#10;Option 4..."></textarea>
        
        <!-- Visual Hint -->
        @if (!bulkText) {
          <div class="absolute bottom-4 right-4 text-[10px] text-slate-400 uppercase tracking-widest font-semibold pointer-events-none">
              One per line
          </div>
        }
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-end gap-3">
      <button 
        (click)="close()" 
        class="px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-200 rounded-lg transition-colors">
        Cancel
      </button>
      <button 
        (click)="submit()"
        [disabled]="!bulkText.trim()"
        class="px-6 py-2 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 disabled:cursor-not-allowed rounded-lg shadow-lg shadow-blue-500/20 transition-all active:scale-95">
        Generate Options
      </button>
    </div>
  </div>